import React from 'react';
import { changeTone, fmtChangePct, fmtPrice, fmtRelativeTime } from '../utils/formatters';

const ClockIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="#636369" strokeWidth="1.5">
        <circle cx="8" cy="8" r="6" />
        <path d="M8 5v3l2 1.5" strokeLinecap="round" />
    </svg>
);

const PushPinIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="#2aa97a" strokeWidth="1.5">
        <path d="M9.5 2.5L13.5 6.5" strokeLinecap="round" />
        <path d="M6 5L11 10" />
        <path d="M2.5 13.5L6.5 9.5" strokeLinecap="round" />
        <path d="M9.5 2.5C9.5 2.5 11 4 10 6C9 8 6.5 9.5 6.5 9.5L6 5L9.5 2.5Z" />
    </svg>
);

const UpIcon = () => (
    <svg width="9" height="8" viewBox="0 0 9 8" fill="none">
        <path d="M3.59979 0.5C3.98469 -0.166667 4.94695 -0.166666 5.33185 0.5L8.79595 6.5C9.18085 7.16667 8.69972 8 7.92992 8H1.00172C0.231919 8 -0.249207 7.16667 0.135694 6.5L3.59979 0.5Z" fill="currentColor" />
    </svg>
);

const DownIcon = () => (
    <svg width="9" height="8" viewBox="0 0 9 8" fill="none">
        <path d="M3.59882 7.5C3.98372 8.16667 4.94597 8.16667 5.33087 7.5L8.79497 1.5C9.17987 0.833334 8.69874 0 7.92894 0H1.00074C0.230942 0 -0.250183 0.833333 0.134717 1.5L3.59882 7.5Z" fill="currentColor" />
    </svg>
);

const PRICE_BADGE_TONE = {
    up: 'bg-[#34D3990D] border-[#AEEDD6]',
    down: 'bg-[#FF6B6B0D] border-[#FFC4C4]',
    neutral: 'bg-[#F3F4F6] border-[#EDEFF3]',
};

const PCT_COLOR = {
    up: 'text-[#2AA97A]',
    down: 'text-[#FF6B6B]',
    neutral: 'text-[#636369]',
};

function cleanText(text) {
    return (text || '').toString().trim();
}

const WatchlistIcon = () => (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.99953 8.86362L8.56453 10.441C8.63108 10.4814 8.70812 10.5011 8.7859 10.4978C8.86368 10.4944 8.93872 10.468 9.00152 10.422C9.06433 10.376 9.11209 10.3124 9.13877 10.2393C9.16545 10.1662 9.16985 10.0868 9.15141 10.0111L8.45391 7.06784L10.7367 5.09909C10.7949 5.04798 10.8369 4.98095 10.8574 4.90627C10.878 4.83159 10.8762 4.75252 10.8523 4.67884C10.8284 4.60515 10.7835 4.54008 10.7231 4.49164C10.6626 4.4432 10.5893 4.41353 10.5122 4.40628L7.51641 4.16253L6.36235 1.36878C6.33292 1.2967 6.2827 1.23502 6.21808 1.1916C6.15347 1.14819 6.07738 1.125 5.99953 1.125C5.92168 1.125 5.8456 1.14819 5.78098 1.1916C5.71636 1.23502 5.66614 1.2967 5.63672 1.36878L4.48266 4.16253L1.48688 4.40628C1.40924 4.41309 1.33532 4.44264 1.27438 4.49122C1.21343 4.5398 1.16815 4.60527 1.1442 4.67943C1.12024 4.7536 1.11867 4.83318 1.13968 4.90824C1.1607 4.98329 1.20336 5.05049 1.26235 5.10143L3.54516 7.07018L2.84766 10.0111C2.82922 10.0868 2.83362 10.1662 2.86029 10.2393C2.88697 10.3124 2.93473 10.376 2.99754 10.422C3.06035 10.468 3.13539 10.4944 3.21317 10.4978C3.29095 10.5011 3.36798 10.4814 3.43453 10.441L5.99953 8.86362Z" stroke="#636369" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
);

const PortfolioIcon = () => (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.81205 6.46686C10.111 6.63934 10.4895 6.46262 10.4985 6.11759C10.5199 5.29228 10.3139 4.47201 9.89638 3.74931C9.47878 3.02654 8.87095 2.43834 8.14513 2.04475C7.84179 1.88025 7.49969 2.11979 7.49969 2.46487V4.84403C7.49969 5.02272 7.59505 5.18783 7.74983 5.27712L9.81205 6.46686Z" stroke="#636369" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M6.74456 6.45365C6.28328 6.18495 5.99957 5.69135 5.99957 5.15752V2.00008C5.99957 1.7239 5.77498 1.49716 5.50052 1.52783C4.88671 1.59642 4.29172 1.79086 3.75349 2.10101C3.07038 2.49465 2.50267 3.06085 2.10722 3.74292C1.71177 4.42499 1.50247 5.19899 1.50026 5.9874C1.49805 6.77581 1.70302 7.55097 2.09465 8.23524C2.48627 8.91952 3.05079 9.48889 3.7317 9.88635C4.4126 10.2838 5.18597 10.4954 5.97437 10.4999C6.76277 10.5045 7.53853 10.3018 8.22396 9.91217C8.76346 9.60551 9.2321 9.19152 9.60199 8.69768C9.76798 8.47606 9.68543 8.16673 9.44617 8.02736L6.74456 6.45365Z" stroke="#636369" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M6 6H1.5" stroke="#636369"/>
    </svg>
);

export default function InsightCard({ item, market, onOpen, inWatchlist, inPortfolio }) {
    const price = market?.priceClose ?? null;
    const changePct = market?.pctChange ?? market?.pricePctChgIntraDay ?? null;
    const companyName = market?.companyName || market?.name || '';
    const title = cleanText(item.title);
    const description = cleanText(item.summary);
    const tone = changeTone(changePct);
    const hasPrice = price !== null || changePct !== null;
    const isPinned = !!item.pinned;

    const cardClass = isPinned
        ? 'bg-[#e9faf5] border-[#d6f6eb]'
        : 'bg-white border-[#ececed]';

    return (
        <article
            onClick={() => onOpen?.(item)}
            className={`${cardClass} border rounded-[16px] pt-[16px] pb-[20px] px-[20px] cursor-pointer transition-colors hover:border-[#DDE1E7]`}
        >
            {isPinned && (
                <div className="inline-flex items-center gap-[6px] rounded-full bg-[#d6f6eb] px-[8px] py-[3px] mb-[10px]">
                    <PushPinIcon />
                    <span className="text-[12px] font-medium text-[#2aa97a]">Nổi bật</span>
                </div>
            )}

            {title && (
                <h3 className="text-[16px] font-bold text-[#111827] leading-snug m-0 mb-[8px]">
                    {title}
                </h3>
            )}

            {description && (
                <p className="text-[14px] text-[#636369] leading-relaxed m-0 mb-[12px] line-clamp-5">{description}</p>
            )}

            <div className="flex items-center justify-between gap-[8px]">
                <div className="flex items-center gap-[8px] flex-wrap min-w-0">
                    <div className="flex items-center gap-[6px] shrink-0">
                        <ClockIcon />
                        <span className="text-[12px] text-[#636369]">{fmtRelativeTime(item.snapshot_at)}</span>
                    </div>
                    <div className="flex items-center gap-[6px] min-w-0">
                        <span className="inline-flex items-center gap-[4px] text-[12px] font-bold px-[8px] py-[3px] rounded-[6px] bg-[#f5f5f5] border border-[#ececed] text-[#111827] shrink-0">
                            {item.symbol}
                            {inPortfolio && <PortfolioIcon />}
                            {inWatchlist && <WatchlistIcon />}
                        </span>
                        {companyName && (
                            <span className="text-[10px] font-medium text-[#636369] truncate">{companyName}</span>
                        )}
                    </div>
                </div>

                {hasPrice && (
                    <div className={`inline-flex items-center gap-[4px] px-[8px] py-[3px] rounded-[6px] border shrink-0 ${PRICE_BADGE_TONE[tone]}`}>
                        <span className="text-[12px] font-bold text-[#636369] whitespace-nowrap">
                            {fmtPrice(price)}
                        </span>
                        {changePct !== null && (
                            <span className={`inline-flex items-center gap-[4px] text-[12px] font-bold whitespace-nowrap ${PCT_COLOR[tone]}`}>
                                {tone === 'up' && <UpIcon />}
                                {tone === 'down' && <DownIcon />}
                                {fmtChangePct(changePct)}
                            </span>
                        )}
                    </div>
                )}
            </div>
        </article>
    );
}
